import { combineReducers } from 'redux';

import predictionDataReducerMap, {
    actions as predictionActions,
    selectors as widgetDataSelectors,
} from './appstate';
import widgetNamespace from './types';

const reducer = combineReducers({
    ...predictionDataReducerMap,
});

export {
    predictionActions,
    widgetDataSelectors,
};

export default {
    [widgetNamespace]: reducer,
};
